import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MultiSelectComponent, MultiSelectFilter} from '../multi-select-component';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatDivider} from '@angular/material/divider';
import {MatButton} from '@angular/material/button';

export interface RouteAssignmentStatusItem {
  id: string;
  name: string;
}

@Component({
  selector: 'app-route-assignment-status-filter',
  templateUrl: './route-assignment-status-filter.component.html',
  styleUrls: ['./route-assignment-status-filter.component.scss'],
  imports: [
    MatCheckbox,
    MatDivider,
    MatButton
  ]
})
export class RouteAssignmentStatusFilterComponent extends MultiSelectComponent<RouteAssignmentStatusItem> implements OnInit {

  @Input() origin;
  @Output() filterChanged = new EventEmitter<MultiSelectFilter<RouteAssignmentStatusItem>>();

  SETTINGS_KEY = 'selectedRouteAssignmentStatus';
  USE_FULLY_CHECKED_AS_DEFAULT = false;

  statusItems: RouteAssignmentStatusItem[] = [
    {
      id: 'PENDING',
      name: 'Pending'
    },
    {
      id: 'DECLINED',
      name: 'Declined'
    },
    {
      id: 'IN_PROGRESS',
      name: 'In progress',
    },
    {
      id: 'COMPLETED',
      name: 'Completed',
    },
    {
      id: 'CANCELLED',
      name: 'Cancelled',
    }
  ];


  constructor() {
    super();
  }

  ngOnInit() {
    // delayed init to workaround failing chip label initialization :-(
    setTimeout(
      () => this.initComponent(this.statusItems),
      500,
    );
  }

  public getLabel(item: RouteAssignmentStatusItem): string {
    return item.name;
  }

  public onApply() {
  }

}
